import styled, { css } from 'styled-components'
import { Typography } from '@mui/material'

export const ModalBox = styled('div')(
  ({ theme }) => css`
    && {
      padding: ${theme.layout.padding.medium};
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background: ${theme.colors.base.white};
      width: 60%;
      margin: ${theme.layout.margin.base * 10}rem auto;

      @media (max-width: ${theme.screen.small}) {
        width: 90%;
      }
    }
  `
)

export const ModalTitle = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      font-family: ${theme.typograph.fontFamily.primary};
      font-weight: 700;
      color: ${theme.colors.primary.main};
      text-align: flex-start;
    }
  `
)

export const ModalDescription = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      font-family: ${theme.typograph.fontFamily.primary};
      text-align: center;
      font-weight: 400;
      margin-top: ${theme.layout.margin.base * 4}rem;

      span {
        font-weight: 700;
      }
    }
  `
)
